import {useNavigate, useLocation, Link} from "react-router-dom";
import React, {useState, useRef} from "react";
import OtpInput from "../OtpInput";
import  {verify_membership_golfer} from "../../API/APICalls";
import ReCAPTCHA from 'react-google-recaptcha';

export default function VerifyMemberOTP(){

    const navigate = useNavigate();
    const location = useLocation();
    const contact_property = location.state;

    
    const [inputs, setInputs] = useState({lastname: '', email: '', handicapID: ''});

    const [otp, setOtp] = useState('');
    const onChange = (value: string) => setOtp(value);
    const [resendError, setResendError] = useState(false);
    const [error, setError] = useState('');

    
    const [isLoading, setIsLoading] = useState(false);

    const recaptchaRef = useRef<ReCAPTCHA>(null);
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

    const handleCaptchaChange = (token: string | null) => {
        setIsCaptchaVerified(!!token);
    };


    const resetCaptcha = () => {
        recaptchaRef.current?.reset();
        setIsCaptchaVerified(false);
      };




    const handleResend = async (event: React.FormEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        setIsLoading(true);
        
        const sentCode = true;

        if (sentCode)
        {
            setResendError(true);
            setIsLoading(false);
        } else {
            setResendError(false);
        }
        


    }
    
    
    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

       setIsLoading(true);

        
        const response = await verify_membership_golfer(otp, contact_property);


        if (JSON.parse(response || '').total > 0)
        {
            navigate('/membership/dashboard', {state: {contact_guid:JSON.parse(response || '').results[0].properties.contact_guid, handicap_id: JSON.parse(response || '').results[0].properties.handicap_id }});
        } else {
            setIsLoading(false);
            setError("The information you have entered is incorrect, please try again!")
        }
    }





    return (
        <div className="container page_container mb-5 pb-5">
        <div className="col-12 col-sm-8 col-md-12 col-lg-8 col-xl-12 col-xxl-12">
          <div className="col-12 col-sm-8 col-md-12 col-lg-12 col-xl-12 my-5 pb-2"><h1 className="fs-1 text-left">Verify Your Identity</h1></div>

          <form name="Verify Code" autoComplete="off" onSubmit={handleSubmit}> 
            
            
          {isLoading ?
            <div className="loaderWrapper">
                    <div className="loader"></div>
                    </div>
            
            :<>
            <div className="pb-3"><h3>Check your email to verify your identity.</h3></div>
            <div className="pb-0 mb-0"><p className="pb-1 mb-0">We sent a six-digit code to your email.</p></div>
            <div className="pb-3">
                <p className="fs-6">Didn't receive it? <a href="" onClick={handleResend} className="text-secondary">Resend code</a></p>
                {resendError ? <p className="fs-5 text-danger">We have successfully sent you a new six-digit code. Please check your email.</p> : ''}
            </div>
            
           

            <OtpInput value={otp} valueLength={6} onChange={onChange} />

            <div className="row pt-4">
            <ReCAPTCHA
        ref={recaptchaRef}
        sitekey="6Le2pp8qAAAAAFDOLCpmqAvWaOI_ZVxcsl9aA9Bc"  // Replace with your actual site key
        onChange={handleCaptchaChange}
      />
      </div>


            <div className="pt-4"><p>If you have any issues or need to update your email - please contact USGA.</p></div>

            <div className="col-12"><p className="text-danger">{error}</p></div>

            <div className="row mt-4 col-12 col-sm-10">
                <div className="col-12 col-sm-6 order-1 pt-3">
                    <Link to="/membership/login" className="w-100 btn btn-outline-secondary btn-lg rounded-pill px-5 " type="button">
                        BACK
                    </Link>
                   
                </div>
                <div className="col-12 col-sm-6 order-sm-1 order-lg-1 pt-3">
                    <button className="btn btn-primary w-100 btn-lg px-5 rounded-pill" type="submit" disabled={!isCaptchaVerified}>
                        CONTINUE
                    </button>
                </div>
            </div>
            </>}
            </form>
        </div>
    </div>
    )
}